import { uniqBy } from 'lodash-es'

export const getRandomId = (name = "") => {
  return `${name}${Math.random()}`
}

export const disposeXAxis = chart => {
  while(chart?.xAxes.length >= 1) {
    chart?.xAxes.removeIndex(0).dispose()
  }
}

export const disposeYAxis = chart => {
  while(chart?.yAxes.length >= 1) {
    chart?.yAxes.removeIndex(0).dispose()
  }
}

export const disposeSeries = chart => {
  while(chart?.series.length >= 1) {
    chart?.series.removeIndex(0).dispose()
  }
}

export const disposeChartChildren = chart => {
  while(chart?.children.length >= 1) {
    chart?.children.removeIndex(0).dispose()
  }
}

export const getAxisData = (data, key) => {
  return uniqBy(data.map(item => {
    return { [key]: item[key] }
  }), key)
}